import i18n from "../../../../utilities/i18n";

/**
 * Convert escalate-claim API error codes to user-friendly messages.
 * Backend returns { code: 400, message: "<error_code>" }
 */
export const handleEscalateClaimErrors = (error) => {
    const msg = error?.message || error?.data?.message || error;
    const knownCodes = [
        "manager_does_not_have_access_to_workflows",
        "invalid_user",
        "support_reason_not_found",
        "invalid_claim_stage",
        "manager_must_be_configured_to_escalate_to_superior",
        "manager_cannot_be_same_as_user_for_escalation",
        "manager_configured_for_user_must_be_active_to_escalate_to_supervisor",
        "claim_stage_already_has_open_escalation_with_same_reason_code",
    ];

    if (typeof msg === "string" && knownCodes.includes(msg)) {
        return { message: i18n.t(`claim_beta.api_errors.${msg}`) };
    }
    

    return { message: i18n.t("claim_beta.api_errors.unexpected_error") };
};

export const formatEscalateError=(data)=>{
    if (data == null || data === "") return null;
    if (typeof data === "string") return data;
    if (typeof data === "object") {
      if (data.message) return String(data.message);
      if (data.detail) return String(data.detail);
      if (Array.isArray(data)) {
        return data
          .map((item) => (typeof item === "string" ? item : JSON.stringify(item)))
          .join("; ");
      }
    }
    try {
      return JSON.stringify(data);
    } catch {
      return "Request failed";
    }
  }


export const getValidationError = (data) => {
    const { 
        currentPracticeId, 
        professionalClaimDetails,
        practiceId, 
        selectedStageIds, 
        reasonId, 
        description, 
        i18n 
    } = data;

    // 1. Practice ID Check
    if (!currentPracticeId || Number.isNaN(practiceId)) {
        return i18n.t("claim_beta.api_errors.practice_not_available");
    }

    // 2. Stage IDs Check (Ensures it's an array and has items)
    if (!professionalClaimDetails?.is_editable && (!Array.isArray(selectedStageIds) || selectedStageIds.length === 0)) {
        return i18n.t("claim_beta.api_errors.invalid_claim_stage") || "Claim stage is missing; cannot submit escalation.";
    }

    // 3. Reason ID Check
    if (reasonId && reasonId.length==0) {
        return i18n.t("claim_beta.api_errors.select_reason_error");
    }

    // 4. Description Check
    if (!description?.trim()) {
        return i18n.t("claim_beta.api_errors.enter_explanation_error");
    }

    return null; // No errors found
};
  

